<template>
    <select
        v-bind="$attrs"
        :value="modelValue"
        @change="handleChangeEvent($event)"
        class="w-full shadow-xs bg-white border border-stone-200 rounded-lg2 disabled:bg-stone-100 disabled:cursor-not-allowed disabled:text-gray-500 disabled:select-none"
        :class="{
            'focus:ring-primary focus:border-primary':
                !useBookingFormThemeCssVariables,
            'focus:ring-booking-form-theme-main-background-color focus:border-booking-form-theme-main-background-color':
                useBookingFormThemeCssVariables,
        }"
    >
        <slot />
    </select>
</template>

<script setup lang="ts">
    const emits = defineEmits<{
        'update:modelValue': [value: string | null]
    }>()

    defineProps({
        modelValue: {
            type: [String, Number, Boolean, null],
            default: null,
        },
        useBookingFormThemeCssVariables: {
            type: Boolean,
            default: false,
        },
    })

    const handleChangeEvent = (event: Event) => {
        const target = event.target as HTMLInputElement | null
        const value = target?.value ?? null
        emits('update:modelValue', value)
    }
</script>
